module.exports = __webpack_public_path__ + "img/f4.d724e36f.png";